// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";
// import { 
//   FaTrash, FaCalendarAlt, FaClock, FaCheckCircle, 
//   FaUserSlash, FaLock, FaUnlock, FaCircle, FaPlus, FaCalendarCheck 
// } from 'react-icons/fa';
// import './AdminPage.css';

// const API_URL = window.location.hostname === "localhost" ? "http://localhost:5001/api/bookings" : "https://haus-of-aura-backend.onrender.com/api/bookings";

// const AdminPage = () => {
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [slots, setSlots] = useState([]);
//   const [bookings, setBookings] = useState([]); 
//   const [view, setView] = useState('availability'); 
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [customSlot, setCustomSlot] = useState(""); 

//   const categories = ["Bridal Makeup", "Studio Service Makeup", "Home Services", "Training"];
//   const [targetCategory, setTargetCategory] = useState(categories[0]);

//   const handleLogout = () => {
//     localStorage.removeItem('adminToken'); 
//     window.location.href = '/admin-login'; 
//   };

//   const getCleanDate = (dateObj) => {
//     const y = dateObj.getFullYear();
//     const m = String(dateObj.getMonth() + 1).padStart(2, '0');
//     const d = String(dateObj.getDate()).padStart(2, '0');
//     return `${y}-${m}-${d}`;
//   };

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const dateStr = getCleanDate(selectedDate);
//       const slotRes = await axios.get(`${API_URL}/admin/slots?date=${dateStr}`);
//       setSlots(slotRes.data);
//       const bookingRes = await axios.get(`${API_URL}/admin/slots/all`);
//       setBookings(bookingRes.data.filter(b => b.date && b.date.startsWith(dateStr)));
//     } catch (err) { 
//       console.error(err); 
//     } finally { 
//       setLoading(false); 
//     }
//   };

//   useEffect(() => { fetchData(); }, [selectedDate]);

//   // SESSIONS STARTING AT 6 AM
//   const SESSIONS = [
//     "06:00 AM – 08:00 AM",
//     "08:00 AM – 10:00 AM",
//     "10:00 AM – 12:00 PM",
//     "12:00 PM – 02:00 PM",
//     "02:00 PM – 04:00 PM",
//     "04:00 PM – 06:00 PM",
//     "06:00 PM – 08:00 PM"
//   ];

//   // 1. BLOCK / UNBLOCK LOGIC
//   const handleToggleBlock = async (slotId) => {
//     try {
//       setLoading(true);
//       await axios.put(`${API_URL}/admin/slots/${slotId}/toggle`);
//       fetchData(); 
//     } catch (err) {
//       setMessage("Failed to update status.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 2. NO-SHOW LOGIC
//   const handleNoShow = async (bookingId) => {
//     if (!window.confirm("Mark this client as No-Show? This will release the slot back to the website.")) return;
//     try {
//       setLoading(true);
//       await axios.put(`${API_URL}/admin/bookings/${bookingId}/no-show`);
//       setMessage("Slot released.");
//       fetchData(); 
//     } catch (err) {
//       setMessage("Error.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 3. ADD CUSTOM SINGLE SLOT
//   const addSingleSlot = async () => {
//     if (!customSlot) return alert("Please enter a time (e.g. 07:00 AM – 09:00 AM)");
//     try {
//       setLoading(true);
//       const dateStr = getCleanDate(selectedDate);
//       await axios.post(`${API_URL}/admin/slots`, { 
//         slots: [{ date: dateStr, timeSlot: customSlot, serviceType: targetCategory, isBooked: false }] 
//       });
//       setCustomSlot("");
//       fetchData();
//       setMessage("Custom slot added!");
//     } catch (err) { 
//       setMessage("Error adding custom slot."); 
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 4. PUBLISH TOOLS
//   const publishDay = async () => {
//     setMessage("Publishing Day...");
//     const dateStr = getCleanDate(selectedDate);
//     const newSlots = SESSIONS.map(s => ({ date: dateStr, timeSlot: s, serviceType: targetCategory, isBooked: false }));
//     try {
//       await axios.post(`${API_URL}/admin/slots`, { slots: newSlots });
//       setMessage("Standard Sessions Live!");
//       fetchData();
//     } catch (err) { setMessage("Error."); }
//   };

//   const publishMonth = async () => {
//     const monthName = selectedDate.toLocaleString('default', { month: 'long' });
//     if (!window.confirm(`Publish standard sessions for all of ${monthName}?`)) return;
//     setMessage("Generating Month...");
//     const year = selectedDate.getFullYear();
//     const month = selectedDate.getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const allMonthSlots = [];
//     for (let day = 1; day <= daysInMonth; day++) {
//         const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
//         SESSIONS.forEach(s => allMonthSlots.push({ date: dateStr, timeSlot: s, serviceType: targetCategory, isBooked: false }));
//     }
//     try {
//       await axios.post(`${API_URL}/admin/slots`, { slots: allMonthSlots });
//       setMessage(`${monthName} Published!`);
//       fetchData();
//     } catch (err) { setMessage("Error."); }
//   };

//   // 5. CLEAR TOOLS
//   const clearEntireMonth = async () => {
//     const monthName = selectedDate.toLocaleString('default', { month: 'long' });
//     if (!window.confirm(`DELETE EVERYTHING for ${monthName}? This cannot be undone.`)) return;
//     const year = selectedDate.getFullYear();
//     const month = selectedDate.getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const datesToDelete = [];
//     for (let d = 1; d <= daysInMonth; d++) {
//         datesToDelete.push(`${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
//     }
//     try {
//       setLoading(true);
//       await axios.post(`${API_URL}/admin/slots/delete-multiple`, { dates: datesToDelete });
//       setMessage(`${monthName} Cleared!`);
//       fetchData();
//     } catch (err) { 
//       setMessage("Error clearing month."); 
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="admin-container">
//       <header className="admin-header">
//         <h1>Haus Of Aura Admin</h1>
//         <div className="admin-nav-tabs">
//             <button className={view === 'availability' ? 'active' : ''} onClick={() => setView('availability')}>Availability</button>
//             <button className={view === 'bookings' ? 'active' : ''} onClick={() => setView('bookings')}>Clients</button>
//             <button onClick={handleLogout} className="logout-btn-tab">Logout</button>
//         </div>
//       </header>

//       <div className="admin-layout">
//         <div className="admin-sidebar">
//           <div className="admin-card">
//             <h3><FaCalendarAlt /> 1. Pick Date</h3>
//             <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} inline />
//           </div>

//           <div className="admin-card">
//             <h3><FaClock /> 2. Session Tools</h3>
//             <label className="cat-text">Category</label>
//             <select value={targetCategory} onChange={(e) => setTargetCategory(e.target.value)} className="admin-select">
//               {categories.map(c => <option key={c} value={c}>{c}</option>)}
//             </select>
            
//             <button className="publish-btn" onClick={publishDay}>Open Sessions (Day)</button>
//             <button className="publish-btn" onClick={publishMonth} style={{background: '#3D2B1F'}}><FaCalendarCheck /> Publish Full Month</button>
            
//             <hr style={{margin: '15px 0', opacity: 0.1}} />
            
//             <label className="cat-text">Add Custom Time</label>
//             <input 
//                 className="admin-input" 
//                 placeholder="e.g. 07:00 AM – 09:00 AM" 
//                 value={customSlot}
//                 onChange={(e) => setCustomSlot(e.target.value)}
//             />
//             <button className="publish-btn" style={{background: '#8a715e'}} onClick={addSingleSlot}><FaPlus /> Add This Slot</button>

//             <hr style={{margin: '15px 0', opacity: 0.1}} />
            
//             <button className="clear-btn" onClick={() => axios.post(`${API_URL}/admin/slots/delete-day`, { date: getCleanDate(selectedDate) }).then(fetchData)}>Clear Day</button>
//             <button className="clear-btn" onClick={clearEntireMonth} style={{borderColor: '#cf1322', marginTop: '10px'}}><FaTrash /> Clear Entire Month</button>
            
//             {message && <p className="status-msg">{message}</p>}
//           </div>
//         </div>

//         <div className="admin-main-content">
//           <div className="admin-card">
//             <h3>{selectedDate.toDateString()}</h3>
//             {loading ? <p>Processing...</p> : (
//               <div className="slots-list-grid">
//                 {view === 'availability' ? (
//                    slots.length > 0 ? slots.map((slot) => (
//                     <div key={slot._id} className={`slot-row ${slot.isBooked ? 'is-blocked-row' : 'is-available-row'}`}>
//                       <div className="slot-info">
//                         <FaCircle style={{ color: slot.isBooked ? '#cf1322' : '#25D366', fontSize: '10px', marginRight: '10px' }} />
//                         <b>{slot.timeSlot}</b> <small>{slot.serviceType}</small>
//                       </div>
                      
//                       <div className="slot-actions">
//                         <button 
//                           className={`status-toggle-btn ${slot.isBooked ? 'unblock-btn' : 'block-btn'}`}
//                           onClick={() => handleToggleBlock(slot._id)}
//                         >
//                           {slot.isBooked ? <><FaUnlock /> Unblock Slot</> : <><FaLock /> Block Time</>}
//                         </button>

//                         {!slot.isBooked && (
//                           <FaTrash className="slot-del-btn" onClick={() => axios.delete(`${API_URL}/admin/slots/${slot._id}`).then(fetchData)} />
//                         )}
                        
//                         {slot.isBooked && <span className="admin-status-tag">BLOCKED / BOOKED</span>}
//                       </div>
//                     </div>
//                   )) : <p>No sessions live. Select a category and click "Open Sessions".</p>
//                 ) : (
//                   bookings.length > 0 ? bookings.map((b, i) => (
//                     <div key={b._id} className={`item-row ${b.status === 'no-show' ? 'no-show-row' : ''}`}>
//                        <div className="item-main">
//                           <strong>{b.name}</strong> {b.timeSlot}
//                           {b.status === 'no-show' && <span className="no-show-badge">NO-SHOW</span>}
//                        </div>
//                        <div className="item-sub">{b.phone} | {b.specificService}</div>
//                        {b.status !== 'no-show' && (
//                          <button className="no-show-action-btn" onClick={() => handleNoShow(b._id)}>
//                            <FaUserSlash /> Mark No-Show
//                          </button>
//                        )}
//                     </div>
//                   )) : <p>No bookings found for this day.</p>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminPage;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { 
  FaTrash, FaCalendarAlt, FaClock, FaCheckCircle, 
  FaUserSlash, FaLock, FaUnlock, FaCircle, FaPlus, FaCalendarCheck 
} from 'react-icons/fa';
import './AdminPage.css';

const API_URL = window.location.hostname === "localhost" ? "http://localhost:5001/api/bookings" : "https://haus-of-aura-backend.onrender.com/api/bookings";

const AdminPage = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [slots, setSlots] = useState([]);
  const [bookings, setBookings] = useState([]); 
  const [view, setView] = useState('availability'); 
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [customSlot, setCustomSlot] = useState(""); 

  const categories = ["Bridal Makeup", "Studio Service Makeup", "Home Services", "Training"];
  const [targetCategory, setTargetCategory] = useState(categories[0]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken'); 
    window.location.href = '/admin-login'; 
  };

  const getCleanDate = (dateObj) => {
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, '0');
    const d = String(dateObj.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const dateStr = getCleanDate(selectedDate);
      const slotRes = await axios.get(`${API_URL}/admin/slots?date=${dateStr}`);
      setSlots(slotRes.data);
      const bookingRes = await axios.get(`${API_URL}/admin/slots/all`);
      setBookings(bookingRes.data.filter(b => b.date && b.date.startsWith(dateStr)));
    } catch (err) { 
      console.error(err); 
    } finally { 
      setLoading(false); 
    }
  };

  useEffect(() => { fetchData(); }, [selectedDate]);

  const handleToggleBlock = async (slotId) => {
    try {
      setLoading(true);
      await axios.put(`${API_URL}/admin/slots/${slotId}/toggle`);
      fetchData(); 
    } catch (err) {
      setMessage("Failed to update status.");
    } finally {
      setLoading(false);
    }
  };

  const handleMarkPaid = async (bookingId) => {
    try {
      setLoading(true);
      await axios.put(`${API_URL}/admin/bookings/${bookingId}/paid`);
      fetchData();
      setMessage("Payment Confirmed!");
    } catch (err) {
      setMessage("Error updating payment.");
    } finally {
      setLoading(false);
    }
  };

  const handleNoShow = async (bookingId) => {
    if (!window.confirm("Mark this client as No-Show? This will release the slot back to the public.")) return;
    try {
      setLoading(true);
      await axios.put(`${API_URL}/admin/bookings/${bookingId}/no-show`);
      fetchData(); 
    } catch (err) {
      setMessage("Error.");
    } finally {
      setLoading(false);
    }
  };

  const addSingleSlot = async () => {
    if (!customSlot) return alert("Enter a time (e.g. 07:00 AM – 09:00 AM)");
    try {
      setLoading(true);
      const dateStr = getCleanDate(selectedDate);
      await axios.post(`${API_URL}/admin/slots`, { 
        slots: [{ date: dateStr, timeSlot: customSlot, serviceType: targetCategory, isBooked: false }] 
      });
      setCustomSlot("");
      fetchData();
      setMessage("Custom slot added!");
    } catch (err) { setMessage("Error."); }
    finally { setLoading(false); }
  };

  const SESSIONS = [
    "06:00 AM – 08:00 AM",
    "08:00 AM – 10:00 AM",
    "10:00 AM – 12:00 PM",
    "12:00 PM – 02:00 PM",
    "02:00 PM – 04:00 PM",
    "04:00 PM – 06:00 PM",
    "06:00 PM – 08:00 PM"
  ];

  const publishDay = async () => {
    setMessage("Publishing Day...");
    const dateStr = getCleanDate(selectedDate);
    const newSlots = SESSIONS.map(s => ({ date: dateStr, timeSlot: s, serviceType: targetCategory, isBooked: false }));
    try {
      await axios.post(`${API_URL}/admin/slots`, { slots: newSlots });
      fetchData();
    } catch (err) { setMessage("Error."); }
  };

  const clearEntireMonth = async () => {
    const monthName = selectedDate.toLocaleString('default', { month: 'long' });
    if (!window.confirm(`DELETE EVERYTHING for ${monthName}?`)) return;
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const datesToDelete = [];
    for (let d = 1; d <= daysInMonth; d++) {
        datesToDelete.push(`${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
    }
    try {
      setLoading(true);
      await axios.post(`${API_URL}/admin/slots/delete-multiple`, { dates: datesToDelete });
      fetchData();
    } catch (err) { setMessage("Error."); }
    finally { setLoading(false); }
  };

  return (
    <div className="admin-container">
      <header className="admin-header">
        <h1>Haus Of Aura Admin</h1>
        <div className="admin-nav-tabs">
            <button className={view === 'availability' ? 'active' : ''} onClick={() => setView('availability')}>Availability</button>
            <button className={view === 'bookings' ? 'active' : ''} onClick={() => setView('bookings')}>Clients</button>
            <button onClick={handleLogout} className="logout-btn-tab">Logout</button>
        </div>
      </header>

      <div className="admin-layout">
        <div className="admin-sidebar">
          <div className="admin-card">
            <h3><FaCalendarAlt /> 1. Pick Date</h3>
            <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} inline />
          </div>

          <div className="admin-card">
            <h3><FaClock /> 2. Session Tools</h3>
            <label className="cat-text">Category</label>
            <select value={targetCategory} onChange={(e) => setTargetCategory(e.target.value)} className="admin-select">
              {categories.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <button className="publish-btn" onClick={publishDay}>Open Sessions (Day)</button>
            
            <hr style={{margin: '15px 0', opacity: 0.1}} />
            <label className="cat-text">Add Custom Time</label>
            <input className="admin-input" placeholder="07:00 AM – 09:00 AM" value={customSlot} onChange={(e) => setCustomSlot(e.target.value)} />
            <button className="publish-btn" style={{background: '#8a715e'}} onClick={addSingleSlot}><FaPlus /> Add Slot</button>

            <hr style={{margin: '15px 0', opacity: 0.1}} />
            <button className="clear-btn" onClick={() => axios.post(`${API_URL}/admin/slots/delete-day`, { date: getCleanDate(selectedDate) }).then(fetchData)}>Clear Day</button>
            <button className="clear-btn" onClick={clearEntireMonth} style={{borderColor: '#cf1322', marginTop: '10px'}}><FaTrash /> Clear Month</button>
            {message && <p className="status-msg">{message}</p>}
          </div>
        </div>

        <div className="admin-main-content">
          <div className="admin-card">
            <h3>{selectedDate.toDateString()}</h3>
            {loading ? <p>Processing...</p> : (
              <div className="slots-list-grid">
                {view === 'availability' ? (
                   slots.length > 0 ? slots.map((slot) => (
                    <div key={slot._id} className={`slot-row ${slot.isBooked ? 'is-blocked-row' : 'is-available-row'}`}>
                      <div className="slot-info">
                        <FaCircle style={{ color: slot.isBooked ? '#cf1322' : '#25D366', fontSize: '10px', marginRight: '10px' }} />
                        <b>{slot.timeSlot}</b> <small>{slot.serviceType}</small>
                      </div>
                      <div className="slot-actions">
                        <button className={`status-toggle-btn ${slot.isBooked ? 'unblock-btn' : 'block-btn'}`} onClick={() => handleToggleBlock(slot._id)}>
                          {slot.isBooked ? 'Unblock' : 'Block'}
                        </button>
                        {!slot.isBooked && <FaTrash className="slot-del-btn" onClick={() => axios.delete(`${API_URL}/admin/slots/${slot._id}`).then(fetchData)} />}
                        {slot.isBooked && <span className="admin-status-tag">BUSY</span>}
                      </div>
                    </div>
                  )) : <p>No sessions live.</p>
                ) : (
                  bookings.length > 0 ? bookings.map((b, i) => (
                    <div key={b._id} className={`item-row ${b.status === 'no-show' ? 'no-show-row' : ''} ${b.status === 'paid' ? 'paid-row' : ''}`}>
                       <div className="item-main">
                          <strong>{b.name}</strong> {b.timeSlot}
                          {b.status === 'no-show' && <span className="no-show-badge">NO-SHOW</span>}
                          {b.status === 'paid' && <span className="paid-badge">PAID</span>}
                       </div>
                       <div className="item-sub">{b.phone} | {b.specificService}</div>
                       <div className="admin-actions-wrap" style={{marginTop: '10px', display: 'flex', gap: '10px'}}>
                         {b.status === 'confirmed' && (
                           <button className="mark-paid-btn" style={{background: '#25D366', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer'}} onClick={() => handleMarkPaid(b._id)}>
                             <FaCheckCircle /> Confirm Payment
                           </button>
                         )}
                         {b.status !== 'no-show' && b.status !== 'paid' && (
                           <button className="no-show-action-btn" onClick={() => handleNoShow(b._id)}>
                             <FaUserSlash /> Mark No-Show
                           </button>
                         )}
                       </div>
                    </div>
                  )) : <p>No bookings found.</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;